import { AutoAwesome } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

export const magicButtonProps = ({loading}: {loading: boolean}) => ({
  variant: 'contained',
  startIcon: loading ? <CircularProgress size={24} /> : <AutoAwesome />,
  color: 'ai',
  disabled: loading,
} as const);
